(function(){
  'use strict';
  /* FNY | Order gate - hides Add to cart for logged-out visitors and for
     customers without an approved B2B trade tag. Prices stay visible.
     Config comes from snippets/fny-order-gate.liquid. */

  var node = document.querySelector('script[data-fny-gate]');
  if (!node) return;
  var G;
  try { G = JSON.parse(node.textContent); } catch (e) { return; }
  if (!G || G.can_order) return;

  var types = {};
  for (var i = 0; i < (G.types || []).length; i++) {
    var tt = String(G.types[i] || '').trim().toLowerCase();
    if (tt) types[tt] = true;
  }
  var pType = String(G.product_type || '').trim().toLowerCase();
  var lockProduct = !!(pType && types[pType]);

  var TITLE = G.logged_in
    ? 'Your account is not approved for online ordering yet'
    : 'Trade pricing is visible - sign in to place an order';
  var BODY = G.logged_in
    ? 'Prices are shown for reference. Online ordering opens once your trade account is approved for a dealer tier. Contact us and we will finish the approval.'
    : 'Euromaster Cabinet sells to the trade only. Create or sign in to an approved dealer account to add cabinets to a cart and see your tier pricing.';
  var ROWMSG = G.logged_in ? 'Approval required' : 'Sign in to order';

  function style(){
    if (document.getElementById('fny-gate-css')) return;
    var st = document.createElement('style');
    st.id = 'fny-gate-css';
    st.textContent = [
      '.fny-gated .dot-add,.fny-gated .dot-qty,.fny-gated .dot-sel,.fny-gated .dot-lbl,.fny-gated .dot-asmnote,.fny-gated .dot-asmall{display:none !important}',
      '.fny-gate-note{display:flex;align-items:center;gap:14px;flex-wrap:wrap;margin:0 0 14px;padding:13px 16px;border-radius:10px;',
        'background:linear-gradient(180deg,#1e3a5f 0%,#16304f 100%);color:#fff;box-shadow:0 6px 18px rgba(30,58,95,.20)}',
      '.fny-gate-note__ico{flex:0 0 30px;height:30px;border-radius:50%;background:rgba(255,255,255,.15);display:flex;align-items:center;justify-content:center;font-size:15px;line-height:1}',
      '.fny-gate-note__tx{flex:1 1 320px;min-width:220px}',
      '.fny-gate-note__t{display:block;font-size:13px;font-weight:700;text-transform:uppercase;letter-spacing:.045em;margin:0 0 3px}',
      '.fny-gate-note__d{display:block;font-size:11.5px;line-height:1.5;color:rgba(255,255,255,.78);margin:0}',
      '.fny-gate-note__btns{display:flex;gap:8px;flex-wrap:wrap;margin-left:auto}',
      '.fny-gate-btn{display:inline-flex;align-items:center;justify-content:center;padding:9px 16px;border-radius:8px;font-size:13px;font-weight:700;text-decoration:none;white-space:nowrap;transition:.15s}',
      '.fny-gate-btn--p{background:#fff;color:#1e3a5f}',
      '.fny-gate-btn--p:hover{background:#eaf0f8}',
      '.fny-gate-btn--s{background:rgba(255,255,255,.14);color:#fff;border:1px solid rgba(255,255,255,.45)}',
      '.fny-gate-btn--s:hover{background:rgba(255,255,255,.24)}',
      '.fny-gate-row{display:flex;align-items:center;justify-content:center;gap:6px;width:100%;margin:0 0 8px;font-size:12px;font-weight:700;color:#1e3a5f;text-decoration:none;border:1px dashed #b9c4d2;border-radius:7px;padding:9px 12px;background:#f6f8fb;white-space:nowrap}',
      '.fny-gate-row:hover{border-color:#1e3a5f;background:#eaf0f8}',
      '.fny-gate-hide{display:none !important}',
      'html.fny-gate-locked form[action*="/cart/add"] [type="submit"],html.fny-gate-locked [name="add"],html.fny-gate-locked .product-form__submit,html.fny-gate-locked .shopify-payment-button,html.fny-gate-locked .product-sticky-form__variant .button--primary,html.fny-gate-locked .sticky-cart__btn,html.fny-gate-locked .dock__atc,html.fny-gate-locked quantity-input,html.fny-gate-locked .pasm,html.fny-gate-locked .pasm__select,html.fny-gate-locked .product-sticky-form{display:none !important}',
      '@media (max-width:749px){.fny-gate-note__btns{margin-left:0;width:100%}.fny-gate-btn{flex:1 1 auto}}'
    ].join('');
    document.head.appendChild(st);
  }

  function banner(){
    var n = document.createElement('div');
    n.className = 'fny-gate-note';
    var ico = document.createElement('span');
    ico.className = 'fny-gate-note__ico';
    ico.setAttribute('aria-hidden', 'true');
    ico.innerHTML = '<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="3" y="11" width="18" height="10" rx="2"></rect><path d="M7 11V7a5 5 0 0 1 10 0v4"></path></svg>';
    var tx = document.createElement('div');
    tx.className = 'fny-gate-note__tx';
    var t = document.createElement('strong');
    t.className = 'fny-gate-note__t';
    t.textContent = TITLE;
    var d = document.createElement('span');
    d.className = 'fny-gate-note__d';
    d.textContent = BODY;
    tx.appendChild(t); tx.appendChild(d);
    var bs = document.createElement('div');
    bs.className = 'fny-gate-note__btns';
    if (G.logged_in) {
      bs.appendChild(link(G.contact_url, 'Contact us', 'p'));
    } else {
      bs.appendChild(link(G.login_url, 'Log in', 'p'));
      bs.appendChild(link(G.dealer_url, 'Become a dealer', 's'));
    }
    n.appendChild(ico); n.appendChild(tx); n.appendChild(bs);
    return n;
  }

  function link(href, text, kind){
    var a = document.createElement('a');
    a.className = 'fny-gate-btn fny-gate-btn--' + kind;
    a.href = href || '#';
    a.textContent = text;
    return a;
  }

  function gateTable(){
    var wraps = document.querySelectorAll('.dot-wrap');
    for (var w = 0; w < wraps.length; w++) {
      var root = wraps[w];
      root.classList.add('fny-gated');
      var bar = root.querySelector('[data-dot-toolbar] .dot-toolbar__inner') || root.querySelector('[data-dot-toolbar]');
      if (bar && !bar.querySelector('.fny-gate-note')) { bar.insertBefore(banner(), bar.firstChild); }
      var cells = root.querySelectorAll('td.dot-act');
      for (var i = 0; i < cells.length; i++) {
        if (cells[i].querySelector('.fny-gate-row')) continue;
        var a = document.createElement('a');
        a.className = 'fny-gate-row';
        a.href = G.logged_in ? (G.contact_url || '#') : (G.login_url || '#');
        a.textContent = ROWMSG;
        var anchorEl = cells[i].querySelector('.dot-bomtoggle');
        if (anchorEl) { cells[i].insertBefore(a, anchorEl); } else { cells[i].appendChild(a); }
      }
    }
  }

  function gateProduct(){
    if (!lockProduct) return;
    document.documentElement.classList.add('fny-gate-locked');
    var sels = ['form[action*="/cart/add"] [type="submit"]', 'form[action*="/cart/add"] [name="add"]',
      '.product-form__submit', '.shopify-payment-button', 'buy-buttons', '.sticky-cart__btn', '.dock__atc'];
    var hidAny = false;
    for (var s = 0; s < sels.length; s++) {
      var els = document.querySelectorAll(sels[s]);
      for (var i = 0; i < els.length; i++) {
        if (els[i].classList.contains('fny-gate-hide')) continue;
        els[i].classList.add('fny-gate-hide');
        hidAny = true;
      }
    }
    if (!document.querySelector('.fny-gate-note')) {
      var host = document.querySelector('.product-form-wrapper') || document.querySelector('form.product-form') || document.querySelector('form[action*="/cart/add"]');
      if (host && !host.closest('.dot-wrap')) { host.appendChild(banner()); }
    }
    return hidAny;
  }

  function run(){
    style();
    gateTable();
    gateProduct();
  }

  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', run); }
  else { run(); }
  window.addEventListener('load', run);
  window.setTimeout(run, 900);
  window.setTimeout(run, 2500);

  var pending = null;
  try {
    var obs = new MutationObserver(function(){
      if (pending) return;
      pending = window.setTimeout(function(){ pending = null; run(); }, 120);
    });
    obs.observe(document.documentElement, { childList: true, subtree: true });
  } catch (e) {}
})();